// extracted by mini-css-extract-plugin
export var pane = "login_pane-module--pane--XZVyC";
export var playButton = "login_pane-module--playButton--h9ckS";
export var textbox = "login_pane-module--textbox--eh5Fh";